import { ApiResponse, query } from './api';
import { cancelDaypassQuery, getPlannedDaypassesQuery, orderDaypassQuery } from './daypass-customer.query';
import { DaypassOrder, DaypassOrderSuccess, PlannedDaypassInfo } from './daypass-customer.types';

interface DaypassCustomerApiInterface {
  cancelDaypass(
    billingCustomerId: string,
    daypassOrderId: string,
    daypassEventId: string
  ): ApiResponse<{ success: boolean }>;

  orderDaypass(billingCustomerId: string, daypassOrder?: DaypassOrder): ApiResponse<DaypassOrderSuccess>;

  getPlannedDaypasses(billingCustomerId: string): ApiResponse<PlannedDaypassInfo[]>;
}

const DaypassCustomerApi: DaypassCustomerApiInterface = {
  async getPlannedDaypasses(billingCustomerId: string): ApiResponse<PlannedDaypassInfo[]> {
    const response = await query<{ getPlannedDaypasses: PlannedDaypassInfo[] }>({
      query: getPlannedDaypassesQuery,
      variables: { billingCustomerId },
      name: 'getPlannedDaypasses',
    });

    return { data: response.getPlannedDaypasses };
  },

  async orderDaypass(billingCustomerId: string, daypassOrder?: DaypassOrder): ApiResponse<DaypassOrderSuccess> {
    const response = await query<{ orderDaypass: DaypassOrderSuccess }>({
      query: orderDaypassQuery,
      variables: { billingCustomerId, daypassOrder },
      name: 'orderDaypass',
    });

    return { data: response.orderDaypass };
  },

  async cancelDaypass(
    billingCustomerId: string,
    daypassOrderId: string,
    daypassEventId: string
  ): ApiResponse<{ success: boolean }> {
    const response = await query<{ cancelDaypass: { success: boolean } }>({
      query: cancelDaypassQuery,
      variables: { billingCustomerId, daypassOrderId, daypassEventId },
      name: 'cancelDaypass',
    });

    return { data: response.cancelDaypass };
  },
};

export { DaypassCustomerApi };
